<div class="alert alert-danger alert-dismissible error-box" *ngIf="validationMessageBox.visible">
    <div *ngFor="let item of validationMessageBox.items; let i = index;">
        <span *ngIf="showPropertyNames && item.propertyName?.length > 0">{{item.propertyName}}:</span>
        <span *ngFor="let message of item.messages">
         {{message}}
        </span>
    </div>
</div>
